import { Controller } from '@hotwired/stimulus'
import { createApp, h } from 'vue'
import App from '@/apps/login-signup-modal/App.vue'
import VueLadda from '@/apps/shared/components/vue-ladda.vue'
import FaIcon from '@/apps/shared/components/fa-icon.vue'

export default class extends Controller {
  connect() {
    const self = this
    window.loginSignupModalApp = createApp({
      data() {
        return { countryCollection: null }
      },
      beforeMount() {
        this.countryCollection = JSON.parse(self.element.dataset.countryCollection)
      },
      render() {
        return h(App)
      }
    })
      .component('FaIcon', FaIcon)
      .component('VueLadda', VueLadda)

    window.loginSignupModalApp.mount(this.element)
  }

  disconnect() {
    window.loginSignupModalApp.unmount()
    delete window.loginSignupModalApp
  }
}
